export default {
  name: 'recordManagement',
  data () {
    return {
      page: {
        num: 1,
        size: 10
      },
      totalRows: 100,
      labelPosition: 'right',
      formInline: {
        alarmName: '',
        alarmType: '',
        sysId: '',
        alarmTime: '',
        sendState: '',
        alarmContent: ''
      },
      tooltip: true,
      alermType: [],
      tableList: [],
      sendStateData: [
        {
          id: 0,
          value: '成功'
        },
        {
          id: 1,
          value: '失败'
        },
        {
          id: 2,
          value: '待执行'
        },
        {
          id: 3,
          value: '取消'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    // this.queryAlermType()
    this.queryList()
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    /* 预警发送方式转换 */
    alarmChannelSwitch (row) {
      let arr = row.alarmChannel.split(',')
      console.log(arr)
      let str = ''
      if (arr.length) {
        for (let v of arr) {
          if (v === '0') {
            str += ' 短信'
          }
          if (v === '1') {
            str += ' 邮箱'
          }
          if (v === '2') {
            str += ' 内部通知'
          }
        }
      }
      return str
    },
    /* 查询预警类型 */
    queryAlermType (val) {
      let _self = this
      let op = {}
      let sysIds = []
      if (val && val !== 0) {
        sysIds.push(val)
      }
      op.sysIds = sysIds
      this.$axios
        // .get(this.$API.warning.queryAllAlarmType, {})
        // .post('http://172.16.9.104:5010/agw/alarmTypeCtr/queryAllAlarmTypeBySysIds', op)
        .post(this.$API.product.queryAllAlarmTypeBySysIds, op)
        .then(function (r) {
          _self.alermType = r.data.resData.alarmObjectList
        })
        .catch(function (error) {})
    },
    sysChange (val) {
      this.formInline.alarmType = ''
      if (val) {
        this.queryAlermType(val)
      } else {
        this.alermType = []
      }
    },
    /* 表格发送状态转换 */
    sendStateSwitch (row) {
      if (row.sendState === '0') {
        return '成功'
      } else if (row.sendState === '1') {
        return '失败'
      } else if (row.sendState === '2') {
        return '待执行'
      } else if (row.sendState === '3') {
        return '取消'
      } else {
        return ''
      }
    },
    // /* 查询预警类型 */
    // queryAlermType () {
    //   let _self = this
    //   this.$axios
    //     .get(this.$API.warning.queryAllAlarmType, {})
    //     .then(function (r) {
    //       _self.alermType = r.data.resData.alarmObjectList
    //       /* 请求列表接口 */
    //       _self.queryList()
    //     })
    //     .catch(function (error) {})
    // },
    /* 查询列表 */
    queryList () {
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size,
        sysIds: sysIds,
        alarmContent: this.formInline.alarmContent,
        alarmName: this.formInline.alarmName,
        alarmTime: this.formInline.alarmTime,
        alarmType: this.formInline.alarmType,
        sendState: this.formInline.sendState
      }
      let _self = this
      /* 查询预警记录列表 */
      this.$axios
        .post(this.$API.warning.queryAlarmRecodeListByPage, params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 查询 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.size = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/warning/recordManagement.js